export const richTextEditorStrings = {
  placeholder: {
    default: 'Text eingeben...',
  },
  templates: {
    label: 'Vorlage einfügen',
    placeholder: 'Vorlage einfügen',
    empty: 'Keine Vorlagen vorhanden',
  },
  textFormat: {
    bold: {
      label: 'Fett',
      title: 'Fett',
    },
    italic: {
      label: 'Kursiv',
      title: 'Kursiv',
    },
    underline: {
      label: 'Unterstrichen',
      title: 'Unterstrichen',
    },
    strikethrough: {
      label: 'Durchgestrichen',
      title: 'Durchgestrichen',
    },
  },
  textColor: {
    button: {
      label: 'Textfarbe und Hervorhebung',
      title: 'Textfarbe und Hervorhebung',
    },
    dialog: {
      label: 'Textfarbe oder Hervorhebung auswählen',
    },
    textColor: 'Textfarbe',
    highlight: 'Hervorhebung',
    clear: 'Farbe entfernen',
    setTextColorLabel: (colorName: string) => `Textfarbe ${colorName}`,
    setHighlightLabel: (colorName: string) => `Hervorhebung ${colorName}`,
    colors: {
      red: 'Rot',
      orange: 'Orange',
      yellow: 'Gelb',
      green: 'Grün',
      blue: 'Blau',
    },
  },
  blockFormat: {
    heading1: {
      label: 'Überschrift 1',
      title: 'Überschrift 1',
    },
    heading2: {
      label: 'Überschrift 2',
      title: 'Überschrift 2',
    },
    quote: {
      label: 'Zitat',
      title: 'Zitat',
    },
  },
  list: {
    ordered: {
      label: 'Sortierte Liste',
      title: 'Sortierte Liste',
    },
    unordered: {
      label: 'Unsortierte Liste',
      title: 'Unsortierte Liste',
    },
  },
  alignment: {
    left: {
      label: 'Linksbündig',
      title: 'Linksbündig',
    },
    center: {
      label: 'Zentriert',
      title: 'Zentriert',
    },
    right: {
      label: 'Rechtsbündig',
      title: 'Rechtsbündig',
    },
    justify: {
      label: 'Blocksatz',
      title: 'Blocksatz',
    },
  },
  link: {
    button: {
      label: 'Link einfügen oder bearbeiten',
      title: 'Link einfügen oder bearbeiten',
    },
    dialog: {
      title: 'Link bearbeiten',
      label: 'Link-URL:',
      placeholder: 'https://beispiel.de',
    },
    actions: {
      save: {
        label: 'Link speichern',
        text: 'Speichern',
      },
      remove: {
        label: 'Link entfernen',
        text: 'Entfernen',
      },
      cancel: {
        label: 'Abbrechen',
        text: 'Abbrechen',
      },
    },
  },
  table: {
    button: {
      label: 'Tabelle einfügen',
      title: 'Tabelle einfügen',
    },
    dialog: {
      title: 'Tabelle einfügen',
      label: 'Tabelle einfügen',
      rows: {
        label: 'Zeilen:',
      },
      columns: {
        label: 'Spalten:',
      },
    },
    actions: {
      insert: {
        label: 'Tabelle einfügen',
        text: 'Einfügen',
      },
      cancel: {
        label: 'Abbrechen',
        text: 'Abbrechen',
      },
    },
  },
  tableActionMenu: {
    button: {
      label: 'Tabellenaktionen',
      title: 'Tabellenaktionen',
    },
    menu: {
      label: 'Tabellenaktionen-Menü',
    },
    insertRowAbove: 'Zeile oben einfügen',
    insertRowBelow: 'Zeile unten einfügen',
    insertColumnLeft: 'Spalte links einfügen',
    insertColumnRight: 'Spalte rechts einfügen',
    deleteRow: 'Zeile löschen',
    deleteColumn: 'Spalte löschen',
    cellBackgroundColor: 'Zellenhintergrundfarbe',
    deleteTable: 'Tabelle löschen',
  },
  colorPicker: {
    dialog: {
      label: 'Zellenhintergrundfarbe auswählen',
    },
    title: 'Hintergrundfarbe',
    custom: {
      label: 'Benutzerdefiniert:',
      ariaLabel: 'Benutzerdefinierte Hintergrundfarbe',
    },
    clear: 'Farbe entfernen',
    done: 'Fertig',
    setColorLabel: (colorName: string) =>
      `Hintergrundfarbe auf ${colorName} setzen`,
    presetColors: {
      white: 'Weiß',
      lightGray: 'Hellgrau',
      lightBlue: 'Hellblau',
      lightGreen: 'Hellgrün',
      lightYellow: 'Hellgelb',
      lightRed: 'Hellrot',
      lightPurple: 'Helllila',
      lightPink: 'Hellrosa',
    },
  },
};
